import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ssoApi, type ConfigureSsoRequest } from "@repo/api";
import { ssoQueryKeys } from "../queryKeys";

export const useConfigureSso = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ConfigureSsoRequest) => ssoApi.configure(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ssoQueryKeys.config });
    },
  });
};
